// A bulk action records only the base fields it changes. Stage overrides and later
// manual edits remain independent of undo; no complete configuration is restored.
import { normalizeAdapterFieldValue } from "../../../utils/transport-config-helpers";

export function suggestedBaseValue(entry) {
  if (!entry || entry.newValue) return "";
  // Bekanntes Auswahlfeld: Vorschlag immer als SAP-Schlüssel („Internet“ -> default).
  return normalizeAdapterFieldValue(entry.adapterField, entry.targetValue || entry.defaultValue || "").value;
}

export function toggleConfigSuggestions(state, activeBuckets) {
  const cfg = { ...state.cfg };
  const update = (werkKey, sourceId, transform) => {
    const art = cfg[werkKey]?.[sourceId];
    if (!art) return;
    cfg[werkKey] = { ...cfg[werkKey], [sourceId]: { ...art, entries: (art.entries || []).map(transform) } };
  };
  if (state.cfgSuggestionUndo) {
    const byArtifact = new Map();
    for (const change of state.cfgSuggestionUndo) {
      const key = JSON.stringify([change.werkKey, change.sourceId]);
      if (!byArtifact.has(key)) byArtifact.set(key, { werkKey: change.werkKey, sourceId: change.sourceId, parameters: new Map() });
      byArtifact.get(key).parameters.set(change.paramKey, change);
    }
    for (const { werkKey, sourceId, parameters } of byArtifact.values()) {
      update(werkKey, sourceId, entry => {
        const change = parameters.get(entry?.ParameterKey);
        if (!change || entry.newValue !== change.appliedValue || entry.modified !== true) return entry;
        const restored = { ...entry };
        for (const key of ["newValue", "modified"]) {
          if (Object.prototype.hasOwnProperty.call(change.before, key)) restored[key] = change.before[key];
          else delete restored[key];
        }
        return restored;
      });
    }
    return { ...state, cfg, cfgSuggestionUndo: null };
  }
  const changes = [];
  for (const bucket of activeBuckets) {
    for (const [sourceId, plants] of Object.entries(state.sel || {})) {
      if (!plants?.[bucket.key]) continue;
      update(bucket.key, sourceId, entry => {
        const value = suggestedBaseValue(entry);
        if (!value) return entry;
        const before = {};
        for (const key of ["newValue", "modified"]) {
          if (Object.prototype.hasOwnProperty.call(entry, key)) before[key] = entry[key];
        }
        changes.push({ werkKey: bucket.key, sourceId, paramKey: entry.ParameterKey, before, appliedValue: value });
        return { ...entry, newValue: value, modified: true };
      });
    }
  }
  return changes.length ? { ...state, cfg, cfgSuggestionUndo: changes } : state;
}
